import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_RAW_DATA = `${REPORT}_SET_RAW_DATA`;
export const SET_GENERATE_STATE = `${REPORT}_SET_GENERATE_STATE`;
export const CLEAR_GENERATE_STATE = `${REPORT}_CLEAR_GENERATE_STATE`;



// WEBPACK FOOTER //
// ./src/views/RealTimeReport_Table/flow/actionTypes.js